<script setup lang="ts"></script>

<template>
  <div class="flex h-screen flex-col items-center justify-center bg-gray-100">
    <slot />
  </div>
</template>
